import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TableData } from '@/components/Table/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { Button, ExportTableButton, Table } from '@/components';
import styles from './DocumentsWebTable.module.scss';

import { getHeaderColumnsGroup, tableColumns } from './tableColumns';
import DocumentsWebFilters from './DocumentsWebFilters';
import { tableFilters } from './tableFilter';
import { TableFilters } from './TableFiltersType';
import { TransactionDetail } from './DocumentsType';

type DocumentsWebTableProps = {
  isLoading?: boolean;
  data: TransactionDetail[];
  filters: TableFilters;
  setFilters: (filters: TableFilters) => void;
  onSearch: () => void;
};

const DocumentsWebTable: FC<DocumentsWebTableProps> = ({
  isLoading,
  data = [],
  filters,
  setFilters,
  onSearch,
}) => {
  const { t } = useTranslation('exchangesHeaders');
  const headerColumnsGroup = getHeaderColumnsGroup(t, data);
  const submitButtonText = t('submitButton');

  const handleSearchClick = () => {
    onSearch();
  };

  const columnsToExport = [
    'tipoLiquidacion',
    'numeroDeLiquidacion',
    'observacionesLiquidacion',
    'contenedor',
    'armador',
    'tipoDocumento',
    'importe',
    'fechaDocumento',
    'vencimiento',
    'cliente',
  ];

  return (
    <div className={styles.ExchangesTable}>
      <header className={styles.header}>
        <div className={styles.filtersContainer}>
          <DocumentsWebFilters filters={filters} setFilters={setFilters} />
        </div>

        <div className={styles.containerRigth}>
          <Button
            type="submit"
            className={styles.submitButton}
            onClick={handleSearchClick}
            disabled={isLoading}
          >
            <FontAwesomeIcon icon={faMagnifyingGlass} className={styles.icon} />
            {submitButtonText}
          </Button>
        </div>
        <div className={styles.containerExport}>
          <ExportTableButton
            data={data as unknown as TableData}
            columnsToExport={columnsToExport}
          />
        </div>
      </header>
      <div className={styles.tableContainer}>
        <Table
          columns={tableColumns}
          data={data as unknown as TableData}
          isLoading={isLoading}
          headerColumnGroup={headerColumnsGroup}
          className={styles.table}
          filterDisplay="menu"
          filters={tableFilters}
        />
      </div>
    </div>
  );
};

export default DocumentsWebTable;
